import { Anchor } from '@mantine/core';
import { IconLink } from '@tabler/icons-react';
import { handleCascadePathLinkClick } from '../utils';
import styles from '../CascadeEvents.module.css';

interface CascadePathLinkProps {
    href: string;
    label: string;
}

export const CascadePathLink = ({ href, label }: CascadePathLinkProps) => {
    return (
        <Anchor
            href={href}
            c='blue.6'
            onClick={handleCascadePathLinkClick}
            className={styles.inlineLink}
        >
            {label}
            <IconLink size={14} />
        </Anchor>
    );
};
